import { License } from './../models/licence/license';
import { ProductCourse } from "./../models/product/product-course"
import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  CustomURLEncoder,
  isNullOrUndefined,
  toHttpParams,
} from "../../../core/helpers/http-params-extensions"
import { take } from "rxjs/operators"

@Injectable({
  providedIn: "root",
})
export class ProductService {
  // Product
  private get_product_id_url: string
  private post_product_url: string
  private get_product_filter_url: string
  private get_product_all_url: string
  private put_product_url: string
  private get_products_license: string

  // Brand
  private get_brand_all_url: string
  // Combo
  private get_combo_all_url: string
  private get_combo_paginate_url: string
  private get_combo_id_url: string
  private put_combo_id_url: string
  private post_combo_url: string
  private delete_combo_url: string
  // Licence
  private get_licence_matchGroups_url: string
  private get_licence_paginate_url: string
  private get_licence_id_url: string
  private get_licence_brand_id_url: string
  private post_licence_url: string
  private put_licence_url: string
  private get_licenses_of_class: string
  private get_licenses_of_course: string
  private get_licenses_type_url: string
  private get_product_paginate_url: string

  private buildUrls(productUrl: string, courseUrl: string) {
    // Product
    this.post_product_url =
      productUrl + environment.endpointProduct.routes.post_product
    this.get_product_filter_url =
      productUrl + environment.endpointProduct.routes.get_product_filter
    this.get_product_id_url =
      productUrl + environment.endpointProduct.routes.get_product_id
    this.get_product_all_url =
      productUrl + environment.endpointProduct.routes.get_product_getall
    this.put_product_url =
      productUrl + environment.endpointProduct.routes.put_product_id
    this.get_products_license =
      courseUrl + environment.endpointCourse.routes.get_products_license
    this.get_product_paginate_url =
      courseUrl + environment.endpointSchoolProducts.routes.get_product_paginate
    // Licence
    this.post_licence_url =
      productUrl + environment.endpointProduct.routes.post_licence
    this.get_licence_id_url =
      productUrl + environment.endpointProduct.routes.get_licence_id
    this.put_licence_url =
      productUrl + environment.endpointProduct.routes.put_licence_id
    this.get_licence_matchGroups_url =
      productUrl + environment.endpointProduct.routes.get_licence_matchGroups
    this.get_licence_paginate_url =
      productUrl + environment.endpointProduct.routes.get_licence_paginate
    this.get_licenses_of_class =
      productUrl + environment.endpointProduct.routes.get_licenses_of_class
    this.get_licenses_of_course =
      courseUrl + environment.endpointCourse.routes.get_licenses_of_course
    this.get_licenses_type_url =
      courseUrl + environment.endpointLexProduct.routes.get_licenses_type

    // Combo
    this.get_combo_all_url =
      productUrl + environment.endpointProduct.routes.get_combo_getAll
    this.get_combo_paginate_url =
      productUrl + environment.endpointProduct.routes.get_combo_paginate
    this.get_licence_brand_id_url =
      productUrl + environment.endpointProduct.routes.get_combo_brand_id
    this.get_combo_id_url =
      productUrl + environment.endpointProduct.routes.get_combo_id
    this.put_combo_id_url =
      productUrl + environment.endpointProduct.routes.put_combo_id
    this.post_combo_url =
      productUrl + environment.endpointProduct.routes.post_combo
    this.delete_combo_url =
      productUrl + environment.endpointProduct.routes.delete_combo
    // Brand
    this.get_brand_all_url =
      productUrl + environment.endpointProduct.routes.get_brand_getAll
  }

  constructor(private httpClient: HttpClient) {
    this.buildUrls(
      environment.endpointProduct.url,
      environment.endpointCourse.url
    )
  }

  postLicence(licence: any) {
    return this.httpClient.post(this.post_licence_url, licence)
  }

  postProduct(product: any) {
    return this.httpClient.post(this.post_product_url, product)
  }

  getAllProductsFilter(product: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (!isNullOrUndefined(product.AskPage)) {
      params = params.set("AskPage", String(product.AskPage))
    }
    if (!isNullOrUndefined(product.ItensPerPage)) {
      params = params.set("ItensPerPage", String(product.ItensPerPage))
    }
    if (!isNullOrUndefined(product.OrderByFilter)) {
      params = params.set("OrderByFilter", String(product.OrderByFilter))
    }
    if (!isNullOrUndefined(product.IsDesc)) {
      params = params.set("IsDesc", String(product.IsDesc))
    }
    if (product.name) {
      params = params.set("Name", String(product.name))
    }
    if (product.code) {
      params = params.set("Code", String(product.code))
    }
    if (product.Description) {
      params = params.set("Description", String(product.Description))
    }

    return this.httpClient.get<any>(this.get_product_filter_url, { params })
  }

  getLicensesOfClass(classId: string, gradeId: string, schoolId: string) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    params = params.set("ClassId", classId)
    params = params.set("GradeId", gradeId)
    params = params.set("SchoolId", schoolId)
    return this.httpClient.get<any>(this.get_licenses_of_class, { params })
  }

  getLicensesOfCourse(gradeId: string, schoolId: string) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    params = params.set("gradeId", gradeId)
    params = params.set("schoolId", schoolId)
    return this.httpClient.get<any>(this.get_licenses_of_course, { params })
  }

  getOneProduct(ProductId: string) {
    return this.httpClient.get<any>(
      this.get_product_id_url.replace("{productId}", ProductId)
    )
  }

  getOneLicence(id: string) {
    return this.httpClient.get<any>(
      this.get_licence_id_url.replace("{licenceId}", id)
    )
  }

  getStatusProducts(productCourse: ProductCourse) {
    const { ...others } = productCourse
    let params = toHttpParams(others)

    return this.httpClient.get<any>(this.get_products_license, { params })
  }

  getAllCombo() {
    return this.httpClient.get<any>(this.get_combo_all_url)
  }

  GetComboByBrandId(brandId: string) {
    return this.httpClient.get<any>(
      this.get_licence_brand_id_url.replace("{brandId}", brandId)
    )
  }

  getAllBrand() {
    return this.httpClient.get<any>(this.get_brand_all_url)
  }

  getMatchGroups(product: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (product.tenantId) {
      params = params.set("tenantId", product.tenantId)
    }

    if (!isNullOrUndefined(product.schoolIds)) {
      product.schoolIds.map((obj, index) => {
        params = params.set(`schoolIds[${index}]`, obj)
      })
    }

    if (!isNullOrUndefined(product.tagIds)) {
      product.tagIds.map((obj, index) => {
        params = params.set(`tagIds[${index}]`, obj)
      })
    }

    if (!isNullOrUndefined(product.profileIds)) {
      product.profileIds.map((obj, index) => {
        params = params.set(`profileIds[${index}].id`, obj.id)
        params = params.set(
          `profileIds[${index}].numberOfLicences`,
          obj.numberOfLicences
        )
      })
    }

    return this.httpClient.get<any>(this.get_licence_matchGroups_url, {
      params,
    })
  }

  getPaginateLicence(product: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    if (!isNullOrUndefined(product.askPage)) {
      params = params.set("askPage", String(product.askPage))
    }
    if (!isNullOrUndefined(product.itensPerPage)) {
      params = params.set("itensPerPage", String(product.itensPerPage))
    }
    if (product.tenantId) {
      params = params.set("tenantId", String(product.tenantId))
    }
    if (!isNullOrUndefined(product.comboCode)) {
      params = params.set("comboCode", String(product.comboCode))
    }
    if (!isNullOrUndefined(product.comboId)) {
      params = params.set("comboId", String(product.comboId))
    }
    if (!isNullOrUndefined(product.brandId)) {
      params = params.set("brandId", String(product.brandId))
    }
    if (!isNullOrUndefined(product.active)) {
      params = params.set("active", String(product.active))
    }
    if (!isNullOrUndefined(product.orderByFilter)) {
      params = params.set("orderByFilter", String(product.orderByFilter))
    }
    if (!isNullOrUndefined(product.isDesc)) {
      params = params.set("isDesc", String(product.isDesc))
    }
    if (product.name) {
      params = params.set("name", product.name)
    }
    if (!isNullOrUndefined(product.schoolId)) {
      params = params.set("schoolId", String(product.schoolId))
    }
    if (product.licenseOrder) {
      params = params.set("licenseOrder", product.licenseOrder)
    }
    if (!isNullOrUndefined(product.tags)) {
      product.tags.map((obj, index) => {
        params = params.set(`tagsName[${index}]`, obj.tagKey)
      })
    }

    return this.httpClient.get<any>(this.get_licence_paginate_url, { params })
  }

  getPagginateCombo(combo: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    if (!isNullOrUndefined(combo.askPage)) {
      params = params.set("askPage", combo.askPage)
    }
    if (!isNullOrUndefined(combo.itensPerPage)) {
      params = params.set("itensPerPage", combo.itensPerPage)
    }
    if (!isNullOrUndefined(combo.orderByFilter)) {
      params = params.set("orderByFilter", combo.orderByFilter)
    }
    if (!isNullOrUndefined(combo.isDesc)) {
      params = params.set("isDesc", combo.isDesc)
    }

    if (!isNullOrUndefined(combo.comboCode)) {
      params = params.set("comboCode", combo.comboCode)
    }
    if (!isNullOrUndefined(combo.comboName)) {
      params = params.set("comboName", combo.comboName)
    }
    if (!isNullOrUndefined(combo.brandId)) {
      params = params.set("brandId", combo.brandId)
    }
    if (!isNullOrUndefined(combo.productsIds)) {
      combo.productsIds.map((obj, index) => {
        params = params.set(`productsIds[${index}]`, obj.id)
      })
    }

    return this.httpClient.get<any>(this.get_combo_paginate_url, { params })
  }

  getAllProduct() {
    return this.httpClient.get<any>(this.get_product_all_url)
  }

  putProduct(productId: string, product: any) {
    return this.httpClient.put(
      this.put_product_url.replace("{productId}", productId),
      product
    )
  }

  putLicence(licence: License) {
    return this.httpClient.put(
      this.put_licence_url.replace("{licenceId}", licence.id),
      licence
    )
  }

  getComboById(comboId: string) {
    return this.httpClient
      .get(this.get_combo_id_url.replace("{comboId}", comboId))
      .pipe(take(1))
  }

  putCombo(comboId: string, comboName: string, productsIds: Array<any>) {
    const data = { comboName, productsIds }
    return this.httpClient.put(
      this.put_combo_id_url.replace("{comboId}", comboId),
      data
    )
  }

  postCombo(combo: any) {
    return this.httpClient.post(this.post_combo_url, combo).pipe(take(1))
  }

  deleteCombo(comboId: string) {
    return this.httpClient
      .delete(this.delete_combo_url.replace("{comboId}", comboId))
      .pipe(take(1))
  }

  getAllTypesOfLicenses() {
    return this.httpClient.get<any>(this.get_licenses_type_url)
  }
  getPaginate(data) {
    let params = toHttpParams(data)
    return this.httpClient.get(this.get_product_paginate_url, { params })
  }
}
